import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1677ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: false,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  siderWidth: 208,
  token: {
    header: { heightLayoutHeader: 44 },
    pageContainer: { colorBgPageContainer: '#ffffff' },
    bgLayout: '#ffffff',
  },
  menu: { defaultOpenAll: true, ignoreFlatMenu: true, autoClose: false },
  splitMenus: true,
  suppressSiderWhenMenuEmpty: true,
};
export default Settings;
